var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-imgtext-page"},[_c('textImgContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }